import { useFeatureIsOn, useFeatureValue } from "@growthbook/growthbook-react";

import FeaturedNewsHero from "../../components/news/FeaturedNewsHero";
import TopStoriesRow from "../../components/news/TopStoriesRow";
import LatestNewsGrid from "../../components/news/LatestNewsGrid";
import EventSpotlight from "../../components/news/EventSpotlight";
import SectionTitle from "../../components/common/SectionTitle";
import StandingsSection from "../../components/standings/StandingsSection";
import LeagueDescriptionSection from "../../components/home/LeagueDescriptionSection";
import SemiFinalProgramSection from "../../components/home/SemiFinalProgramSection";

import { mockEvents } from "../../data/mockEvents";
import { mockArticles } from "../../data/mockNews";

export default function HomePage() {
    const showStandings = useFeatureIsOn("show-standings-home");
    const showFeaturedEvent = useFeatureIsOn("show-featured-event");
    const showNewsSection = useFeatureIsOn("show-news-home");

    const ctaLabel = useFeatureValue(
        "event-program-cta-copy",
        "Voir le programme"
    );

    const topStories = mockArticles.slice(0, 3);
    const latestArticles = mockArticles.slice(0, 6);

    const featuredEvent =
        mockEvents.find((event) => event.featured) ?? mockEvents[0];

    return (
        <div className="space-y-12 py-6 md:space-y-16">
            <LeagueDescriptionSection />

            <SemiFinalProgramSection />

            {showStandings && <StandingsSection />}

            {showFeaturedEvent && featuredEvent && (
                <section>
                    <SectionTitle title="Événement vedette" />
                    <EventSpotlight event={featuredEvent} />
                </section>
            )}

            {/*{showNewsSection && (*/}
            {/*    <section className="space-y-8">*/}
            {/*        <SectionTitle title="Actualités de la ligue" />*/}

            {/*        <FeaturedNewsHero article={mockArticles[0]} />*/}

            {/*        <TopStoriesRow articles={topStories} />*/}

            {/*        <LatestNewsGrid articles={latestArticles} />*/}
            {/*    </section>*/}
            {/*)}*/}
        </div>
    );
}